import { z } from "zod";

// Skema untuk objek 'data' dalam response API v4
const StatisticDataSchemaV4 = z.object({
    total_booking: z.number(),
    total_booking_sub_month: z.number(),
    total_booking_sub_year: z.number(),
    total_revenue: z.coerce.number(),
    total_revenue_sub_month: z.coerce.number(),
    total_revenue_sub_year: z.coerce.number(),
});

// Skema untuk keseluruhan response API v4
const StatisticResponseV4 = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: StatisticDataSchemaV4,
});

// Mengekspor tipe data yang di-infer dari skema Zod
type StatisticResponseV4Type = z.infer<typeof StatisticResponseV4>;
type StatisticDataV4Type = z.infer<typeof StatisticDataSchemaV4>;

export { StatisticResponseV4, StatisticDataSchemaV4 };
export type { StatisticResponseV4Type, StatisticDataV4Type };